import React from "react";
import { Col, Input, Row, Space } from "antd";
import styles from "./settings.module.scss";
import useAuthenticatedUser from "@/hooks/useAuthenticatedUser";

function ManageAccount() {
  const { userObj } = useAuthenticatedUser();

  return (
    <Row
      className={styles.content}
      gutter={[0, 20]}
    >
      <Col span={24}>
        <Space direction={"vertical"}>
          <span>Email:</span>
          <Input
            style={{ width: "500px" }}
            value={userObj?.signInDetails?.loginId}
            disabled={true}
          ></Input>
        </Space>
      </Col>
    </Row>
  );
}

export default ManageAccount;
